import { DataLoaderParams } from '@/types/DataLoaderParams';
import { fetchCatalogLocationsIfNeeded } from '@/redux/modules/catalogLocation';

export default ({ store }: DataLoaderParams) => {
    const { dispatch } = store;

    return dispatch(fetchCatalogLocationsIfNeeded());
};
